/***
 * @Authors:
 *      Nikhil Chougule
 *      Rahul Kumar
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Style imports */
import './styles.css'
import Gutter from "../../../../Gutter/Gutter";
import LoadingViewSmall from "../../LoadingView/LoadingViewSmall";
/*** End Imports ***/

const GetBoostJobLoadingView = (props) => {

    // helper function
    // event handlers for static component

    return (
        <div className="boost-job-loading-view">
            <div className="bjlv-left">
                <div className = "animated-background"
                     style={{height: 'fit-content',
                         flex : "1",
                         position : "relative",
                         minWidth : "314px",
                         marginRight : "0px"
                     }}
                >
                    <Gutter height={136}/>
                    <div>
                        <div className="background-masker boost-job-section">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-left-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-right-cutter">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-right-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>
                    <div style={{paddingTop:'94px'}}>
                        <div className="background-masker avl-hire-sect-top">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>
                    <div style={{paddingTop:'94px'}}>
                        <div className="background-masker avl-hire-sect-top">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>

                    <div style={{paddingTop:'72px' , height: '100%'}}>
                        <div className="background-masker avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>
                </div>
                <Gutter width={30} height={543}/>
                <div className = "animated-background"
                     style={{height: 'fit-content',
                         flex : "1",
                         position : "relative",
                         minWidth : "314px",
                         marginRight : "0px"
                     }}
                >
                    <Gutter height={136}/>
                    <div>
                        <div className="background-masker boost-job-section">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-left-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-right-cutter">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-right-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker boost-job-section-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>
                    <div style={{paddingTop:'94px'}}>
                        <div className="background-masker avl-hire-sect-top">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>
                    <div style={{paddingTop:'94px'}}>
                        <div className="background-masker avl-hire-sect-top">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker title-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-left">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-right">
                            <div className="background-masker-fix-content"/>
                        </div>
                        <div className="background-masker sub-content-avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>

                    <div style={{paddingTop:'72px' , height: '100%'}}>
                        <div className="background-masker avl-hire-sect-bottom">
                            <div className="background-masker-fix-content"/>
                        </div>
                    </div>
                </div>
            </div>
            <Gutter width={20}/>
            <div className="bjlv-right">
                <LoadingViewSmall/>
                {/*<div className = "animated-background"*/}
                {/*style={{height: 'fit-content',*/}
                {/*flex : "1",*/}
                {/*position : "relative",*/}
                {/*minWidth : "314px",*/}
                {/*marginRight : "0px"*/}
                {/*}}*/}
                {/*>*/}
                {/*<div>*/}
                {/*<div className="background-masker avl-hire-sect-top">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*<div style={{paddingTop:'94px'}}>*/}
                {/*<div className="background-masker avl-hire-sect-top">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*<div style={{paddingTop:'94px'}}>*/}
                {/*<div style={{height: '72px'}} className="background-masker avl-hire-sect-top">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*<div style={{paddingTop:'72px'}}>*/}
                {/*<div className="background-masker avl-hire-sect-top">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*<div style={{paddingTop:'94px'}}>*/}
                {/*<div className="background-masker avl-hire-sect-top">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker title-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-left">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-right">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*<div className="background-masker sub-content-avl-hire-sect-bottom">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*<div style={{paddingTop:'94px'}}>*/}
                {/*<div style={{height: '95px'}} className="background-masker avl-hire-sect-top">*/}
                {/*<div className="background-masker-fix-content"/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*</div>*/}
            </div>


        </div>

    );
};

/**
 * all prop types which can be passed to this component
 */
GetBoostJobLoadingView.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
GetBoostJobLoadingView.defaultProps ={

};

export default GetBoostJobLoadingView;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetBoostJob/GetBoostJobLoadingView/GetBoostJobLoadingView.js